const globalMapping = (data) => {
    const jsonData = data.data;

    if (!jsonData) {
      return {};
    }

    let header = jsonData.find(o => o.type === 'block_content--global_header');
    let footer = jsonData.find(o => o.type === 'block_content--global_footer');

    const mappedData = {};
    const headerData = {};
    const footerData = {};

    headerData.main_button = {
      alt: header.relationships.field_logo?.data.meta.alt,
      title: header.relationships.field_logo?.data.meta.alt,
      image_url: header.relationships.field_logo?.data.uri[0].url,
      aria_label: header.relationships.field_logo?.data.meta.alt
    };

    headerData.search_field = {
      label: header.attributes?.field_search_label,
      title: header.attributes?.field_search_path?.title,
      url: header.attributes?.field_search_path?.url,
    };

    let nav_links = Object.values(header.relationships.field_menu?.data.items).sort(function(a, b) {
      return a.weight - b.weight;
    });

    let links = [];

    for (let menuLink of nav_links) {
      let parentIndex = -1;
      let object = {
        id: menuLink.id,
        title: menuLink.title,
        link: menuLink.url || '/',
        visible: menuLink.enabled === 1,
        type: menuLink.field_page_type[0]?.value ?? '',
        image_url: menuLink.field_menu_image[0]?.url ?? '',
        image_alt: menuLink.field_menu_image[0]?.alt ?? '',
        show_images : menuLink?.field_show_images[0]?.value ?? '',
        sub_nav_options: []
      };

      if (menuLink.parent) {
        parentIndex = links.findIndex((obj => obj.id === menuLink.parent));
      }

      parentIndex === -1
        ? links.push(object)
        : links[parentIndex].sub_nav_options.push(object);
    }

    headerData.nav_options = links;

    footerData.social_media = [];

    const social_media_list = footer.relationships.field_social_media_blocks.data;


    footerData.social_media = social_media_list.map((socialMediaItem)=> {
        return {
            id: socialMediaItem.id,
            href: socialMediaItem.field_social_media_link[0].uri,
            target: '_blank',
            title: socialMediaItem.field_social_media_link[0].title,
            label: socialMediaItem.field_social_media_link[0].title
        }

    });

    footerData.legal = [];

    var footer_links = Object.values(footer.relationships.field_menu.data.items);
    footer_links = footer_links.sort((a, b) => a.weight - b.weight);

    footerData.legal = footer_links.map((footerLink) => {
      return {
          id: footerLink.id,
          label: footerLink.title,
          title: footerLink.title,
          href: footerLink.url,
          target: footerLink.options.attributes.target,
          visible: footerLink.enabled === "1"
      }
    })

    mappedData.header = headerData;
    mappedData.footer = footerData;

    return mappedData;
};

export default globalMapping;
